import React from 'react'

export const CompletionRateListContext = React.createContext()
export const ExternalClickContext = React.createContext()
export const StaticsContext = React.createContext()
export const ProfileContext = React.createContext()